/**
 * @module common/DualAxis/fields/AxisChartTypeField
 * @description 组合图 · 主/次轴图表类型
 */

import React from 'react';
import { useIntl } from 'umi';
import { Radio } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';

interface IAxisChartTypeFieldProps {
  value: string;
  onChange: (chartType: string) => void;
  className?: string;
}

const AxisChartTypeField: React.FC<IAxisChartTypeFieldProps> = ({
  value,
  onChange,
  className = '',
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className={`dbl-chart-setting-row ${className}`}>
      <div className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_primary_chart_type' })}
      </div>
      <div className="dbl-dual-axis-field__chart-type">
        <Radio.Group value={value} onChange={onChange}>
          <Radio name="chart-bar">
            <SvgIcon type="chart-bar" />
          </Radio>
          <Radio name="chart-line">
            <SvgIcon type="chart-line" />
          </Radio>
        </Radio.Group>
      </div>
    </div>
  );
};

export default React.memo(AxisChartTypeField);
